import React from 'react';
import Icon from '../../../components/appIcon';

const PasswordStrengthIndicator = ({ password, isVisible = true }) => {
  if (!isVisible || !password) return null;

  const requirements = [
    {
      id: 'length',
      label: 'At least 8 characters',
      test: (pwd) => pwd?.length >= 8
    },
    {
      id: 'uppercase',
      label: 'One uppercase letter',
      test: (pwd) => /[A-Z]/?.test(pwd)
    },
    {
      id: 'lowercase',
      label: 'One lowercase letter',
      test: (pwd) => /[a-z]/?.test(pwd)
    },
    {
      id: 'number',
      label: 'One number',
      test: (pwd) => /\d/?.test(pwd)
    },
    {
      id: 'special',
      label: 'One special character',
      test: (pwd) => /[!@#$%^&*(),.?":{}|<>]/?.test(pwd)
    }
  ];

  const metRequirements = requirements?.filter(req => req?.test(password));
  const strengthPercentage = (metRequirements?.length / requirements?.length) * 100;

  const getStrengthLevel = () => {
    if (strengthPercentage < 40) return { label: 'Weak', color: 'bg-error' };
    if (strengthPercentage < 80) return { label: 'Medium', color: 'bg-warning' };
    return { label: 'Strong', color: 'bg-success' };
  };

  const strength = getStrengthLevel();

  return (
    <div className="mt-3 space-y-3">
      {/* Strength Bar */}
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-xs font-medium text-muted-foreground">Password Strength</span>
          <span className={`text-xs font-medium ${
            strength?.color === 'bg-error' ? 'text-error' :
            strength?.color === 'bg-warning' ? 'text-warning' : 'text-success'
          }`}>
            {strength?.label}
          </span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className={`h-2 rounded-full enterprise-transition ${strength?.color}`}
            style={{ width: `${strengthPercentage}%` }}
          ></div>
        </div>
      </div>
      {/* Requirements List */}
      <div className="space-y-2">
        <span className="text-xs font-medium text-muted-foreground">Requirements:</span>
        <div className="grid grid-cols-1 gap-1">
          {requirements?.map((requirement) => {
            const isMet = requirement?.test(password);
            return (
              <div key={requirement?.id} className="flex items-center space-x-2">
                <Icon
                  name={isMet ? "CheckCircle2" : "Circle"}
                  size={14}
                  className={isMet ? 'text-success' : 'text-muted-foreground'}
                />
                <span className={`text-xs ${
                  isMet ? 'text-success' : 'text-muted-foreground'
                }`}>
                  {requirement?.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;